import React from 'react';
import Layout from '../components/Layout';
import MyJoyNetFeed from '../UI-Components/MyJoynetFeed/myJoyNetFeed';
import { useSearchParams } from 'react-router-dom';

/* This page will showcase TikTok videos to the user. Each video will have a like button, the amount of likes that the video has, an information button 
that will showcase all the info about the video (caption, creater, hashtags, etc.), and a button to share the video to a community that they are a part of. */

const MyJoyNetPage = () => {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('post');

  return (
    <Layout pageTitle="My JoyNet &#x2728;">
      <MyJoyNetFeed initialPostId={postId} />
    </Layout>
  );
};

export default MyJoyNetPage;